module.exports = __webpack_public_path__ + "static/media/madison-logo-vertical.abbd941e.png";